/* eslint-disable no-unused-vars */

export function usePlugins (app) {

}